export const debounceDelay: number = 200;
export const debounceDelayMedium: number = 500;
export const debounceDelayMediumHigh: number = 900;
export const debounceDelayHigh: number = 1500;
